export const PREFERRED_PAYMENT_METHODS = {
  SEND_INVOICE: 'send_invoice',
  CREDIT_CARD: 'charge_automatically',
};
